import Resource from './Resource'

class MunicipalityResource extends Resource {
    async index(proId) {
        const response = await this.axios.get(`/provinces/${proId}/municipalities/index`)
        return response.data
    }
}

export default new MunicipalityResource()
